import initStateToggler from "../helpers/toggle-state";
import initTriggerResize from "../helpers/trigger-resize";

export default () => {
  // Toggle state
  initStateToggler();

  // Trigger resize
  initTriggerResize();
};



// WEBPACK FOOTER //
// ./src/components/layout/Header.run.js